<template>
  <ReportWrapper
    :loading="loading"
    :on-load="loadReport"
    :tab-lv1-index="tabLv1Index"
    :tab-lv2-index="tabLv2Index"
    :showProviderFilter="true"
  >
    <ReportTable
      title="Prophy (D1110)"
      minWidth="1020px"
    >
      <thead>
        <tr>
          <th><span>Name</span></th>
          <th><span>Gross production</span></th>
          <th><span>Writeoff</span></th>
          <th><span>Adjustment</span></th>
          <th><span>Patient payments</span></th>
          <th><span>Insurance payments</span></th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr
          v-for="(item, index) in prophyDataPerProvider"
          :key="index"
          :class="{
            active: item.isCurrentUserRecord,
            median: item.isMedian,
            hidden: !item.isActive || item.isHidden || item.isHiddenReport,
          }"
        >
          <td>{{ item.fullName }}</td>
          <td>{{ formatMoney(item.prophyGrossProduction) }}</td>
          <td>{{ formatMoney(item.prophyEstimatedWriteoff) }}</td>
          <td>{{ formatMoney(item.prophyCompletedProceduresAdjustment) }}</td>
          <td>{{ formatMoney(item.prophyPatientPayments) }}</td>
          <td>{{ formatMoney(item.prophyInsurancePayments) }}</td>
        </tr>

        <NoRecordsFound
          v-if="!prophyDataPerProvider.length && !loading"
          colspan="6"
        />
      </tbody>
    </ReportTable>

    <ReportTable
      title="Perio (D4910)"
      minWidth="1020px"
    >
      <thead>
        <tr>
          <th><span>Name</span></th>
          <th><span>Gross production</span></th>
          <th><span>Writeoff</span></th>
          <th><span>Adjustment</span></th>
          <th><span>Patient payments</span></th>
          <th><span>Insurance payments</span></th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr
          v-for="(item, index) in perioDataPerProvider"
          :key="index"
          :class="{
            active: item.isCurrentUserRecord,
            median: item.isMedian,
            hidden: !item.isActive || item.isHidden || item.isHiddenReport,
          }"
        >
          <td>{{ item.fullName }}</td>
          <td>{{ formatMoney(item.perioGrossProduction) }}</td>
          <td>{{ formatMoney(item.perioEstimatedWriteoff) }}</td>
          <td>{{ formatMoney(item.perioCompletedProceduresAdjustment) }}</td>
          <td>{{ formatMoney(item.perioPatientPayments) }}</td>
          <td>{{ formatMoney(item.perioInsurancePayments) }}</td>
        </tr>

        <NoRecordsFound
          v-if="!perioDataPerProvider.length && !loading"
          colspan="6"
        />
      </tbody>
    </ReportTable>

    <ReportTable
      title="SRP (D4341, D4342, D4346)"
      minWidth="1020px"
    >
      <thead>
        <tr>
          <th><span>Name</span></th>
          <th><span>Gross production</span></th>
          <th><span>Writeoff</span></th>
          <th><span>Adjustment</span></th>
          <th><span>Patient payments</span></th>
          <th><span>Insurance payments</span></th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr
          v-for="(item, index) in srpDataPerProviderAll"
          :key="index"
          :class="{
            active: item.isCurrentUserRecord,
            median: item.isMedian,
            hidden: !item.isActive || item.isHidden || item.isHiddenReport,
          }"
        >
          <td>{{ item.fullName }}</td>
          <td>{{ formatMoney(item.srpGrossProduction) }}</td>
          <td>{{ formatMoney(item.srpEstimatedWriteoff) }}</td>
          <td>{{ formatMoney(item.srpCompletedProceduresAdjustment) }}</td>
          <td>{{ formatMoney(item.srpPatientPayments) }}</td>
          <td>{{ formatMoney(item.srpInsurancePayments) }}</td>
        </tr>

        <NoRecordsFound
          v-if="!srpDataPerProviderAll.length && !loading"
          colspan="6"
        />
      </tbody>
    </ReportTable>
  </ReportWrapper>
</template>

<script>
import DataService from '../../../../_services/DataService';
import NoRecordsFound from '../../../components/Reporting/NoRecordsFound';
import ReportTable from '../../../components/Reporting/ReportTable.vue';
import ReportWrapper from '../../../components/Reporting/ReportWrapper';
import Utils from '../../../utils';

export default {
  name: 'ClinicHygiene',
  components: {
    NoRecordsFound,
    ReportTable,
    ReportWrapper,
  },
  inject: ['shouldShowHiddenProviders'],
  props: ['tabLv1Index', 'tabLv2Index'],
  data() {
    return {
      prophyDataPerProviderAll: [],
      perioDataPerProviderAll: [],
      srpDataPerProviderAll: [],
      loading: false,
    };
  },
  computed: {
    showHiddenProviders() {
      return this.shouldShowHiddenProviders();
    },
    prophyDataPerProvider() {
      return this.showHiddenProviders
        ? this.prophyDataPerProviderAll
        : this.prophyDataPerProviderAll.filter(this.providerIsVisible);
    },
    perioDataPerProvider() {
      return this.showHiddenProviders
        ? this.perioDataPerProviderAll
        : this.perioDataPerProviderAll.filter(this.providerIsVisible);
    },
    srpDataPerProvider() {
      return this.showHiddenProviders
        ? this.srpDataPerProviderAll
        : this.srpDataPerProviderAll.filter(this.providerIsVisible);
    },
  },
  methods: {
    async loadReport(dateRange) {
      const { start, end } = dateRange;
      this.loading = true;

      const result = await DataService.getClinicHygieneReport({ start, end });

      if (result.status === 200) {
        const { prophyDataPerProvider = [], perioDataPerProvider = [], srpDataPerProvider = [] } = result.data;

        this.prophyDataPerProviderAll = prophyDataPerProvider;
        this.perioDataPerProviderAll = perioDataPerProvider;
        this.srpDataPerProviderAll = srpDataPerProvider;
      } else {
        this.prophyDataPerProviderAll = this.perioDataPerProviderAll = this.srpDataPerProviderAll = [];
      }

      this.loading = false;
    },
    formatMoney(number) {
      return Utils.formatCurrency(number, false, false);
    },
    providerIsVisible(provider) {
      return provider.isActive && !provider.isHidden && !provider.isHiddenReport;
    },
  },
};
</script>
